import { render } from "./ReportIndex.vue?vue&type=template&id=73111dbf&ts=true"
import script from "./ReportIndex.vue?vue&type=script&lang=ts"
export * from "./ReportIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__